import { linearGradient } from '../../../../internal/styles/linearGradient';
import { type BannerBoxTokens } from '../types';

export const bannerBox: BannerBoxTokens = {
  colors: {
    borderTop: '#27A0A0',
    background: '#F5F5F5',
    background2: '#1C708C',
    background5: '#FF7E29',
  },
  backgroundImage: {
    base: null,
    gradient: linearGradient('90deg', ['primary.90', '#000000']),
  },
};
